import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class ResourcesPeoplePersonEditRoute extends Route {
  model() {
    return this.modelFor('resources.people.person');
  }
}

export default instrumentRoutePerformance(ResourcesPeoplePersonEditRoute);
